import type { TripPlannerSurfaceActivityEntry } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityEntryTypes'
import { boundActivityDisplayText } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityDisplayText'

export function buildOfferDrawerOpenedActivityEntry(name: string, offerType: string): TripPlannerSurfaceActivityEntry {
  return {
    kind: 'offer_drawer_opened',
    label: 'Opened offer details',
    displayText: boundActivityDisplayText(`Opened ${offerType} "${name}"`),
    sourcePath: 'trip_planner.drawer.offer',
    dataClassification: 'personalised_surface',
    occurredAt: new Date().toISOString(),
  }
}
